<template lang="pug">
.novelty-data-actions(@click.stop="")
  .novelty-data-actions__icons
    RemitDataIcon(
      :record="order"
      :icon-color="iconColor"
      :icon-size="iconSize"
    )
    DeliveryDataIcon(
      v-if="hasDeliveries"
      :record="order"
      :icon-size="iconSize"
      @refresh="$emit('refresh')"
    )
    shActionButton(
      v-if="canQuote"
      :action="quoteOrder"
      icon="request_quote"
      text="Cotizar"
      textRunning="Cotizando"
      :normalColor="true"
    )
    shActionButton(
      v-if="canGenerateGuide"
      :action="generateGuide"
      icon="package_2"
      text="Generar guía"
      textRunning="Generando guía"
      :normalColor="true"
      :textConfirmation="generateGuideConfirmation"
    )
    shActionButton(
      v-if="canGenerateCollectGuide"
      :action="generateCollectGuide"
      icon="inventory_2"
      text="Guía al cobro"
      textRunning="Generando al cobro"
      :normalColor="true"
      :textConfirmation="collectGuideConfirmation"
    )
</template>

<script>
import { mapActions } from 'vuex'
import mFilters from '@/mixins/filters'
import RemitDataIcon from '@/components/elements/remit/RemitDataIcon.vue'
import DeliveryDataIcon from '@/components/elements/delivery/DeliveryDataIcon.vue'
import shActionButton from '@/components/elements/ActionButton.vue'
import { recordHasDeliveries } from '@/helpers/deliveryMass'
import {
  canQuoteDataNovelty,
  canGenerateDataNoveltyGuide,
  canGenerateDataNoveltyCollectGuide
} from '@/helpers/orderNovelty'

export default {
  name: 'NoveltyDataActions',

  mixins: [mFilters],

  components: {
    RemitDataIcon,
    DeliveryDataIcon,
    shActionButton
  },

  props: {
    order: {
      type: Object,
      required: true
    },
    iconColor: {
      type: String,
      default: 'var(--color-placeholder)'
    },
    iconSize: {
      type: String,
      default: '1.75rem'
    }
  },

  computed: {
    hasDeliveries () {
      return recordHasDeliveries(this.order)
    },

    canQuote () {
      return canQuoteDataNovelty(this.order)
    },

    canGenerateGuide () {
      return canGenerateDataNoveltyGuide(this.order)
    },

    canGenerateCollectGuide () {
      return canGenerateDataNoveltyCollectGuide(this.order)
    },

    generateGuideConfirmation () {
      return `Se generará la guía para la orden ${this.order.order}`
    },

    collectGuideConfirmation () {
      return `Se generará la guía al cobro para ${this.order.order}. Flete estimado ${this.money(this.order.coordinadoraCost)} lo paga el cliente.`
    }
  },

  methods: {
    ...mapActions('orderNovelty', [
      'quoteDataNoveltyOrder',
      'generateDataNoveltyGuide'
    ]),

    needsCustomDimensions () {
      return this.order.package === 'otro' && !this.order.packageDimensions
    },

    async quoteOrder () {
      if (this.needsCustomDimensions()) {
        this.$emit('need-package', 'quote')
        return true
      }

      await this.runQuote(this.order.packageDimensions || null)
      return true
    },

    async runQuote (packageDimensions, order = this.order) {
      const result = await this.quoteDataNoveltyOrder({
        order,
        packageDimensions
      })

      if (result && result.needsPackageDimensions) {
        this.$emit('need-package', 'quote')
      }
    },

    async generateGuide () {
      if (this.needsCustomDimensions()) {
        this.$emit('need-package', 'guide')
        return true
      }

      await this.runGenerateGuide(false, this.order.packageDimensions || null)
      return true
    },

    async generateCollectGuide () {
      if (this.needsCustomDimensions()) {
        this.$emit('need-package', 'collect')
        return true
      }

      await this.runGenerateGuide(true, this.order.packageDimensions || null)
      return true
    },

    async runGenerateGuide (collectFreight, packageDimensions, order = this.order) {
      const result = await this.generateDataNoveltyGuide({
        order,
        packageDimensions,
        collectFreight
      })

      if (result && result.needsPackageDimensions) {
        this.$emit('need-package', collectFreight ? 'collect' : 'guide')
        return
      }

      if (result && result.success) {
        this.$emit('refresh')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.novelty-data-actions
  display flex
  align-items center
  justify-content flex-end
  min-width 0

.novelty-data-actions__icons
  display inline-flex
  align-items center
  justify-content flex-end
  flex-wrap wrap
  gap .35rem
</style>



// WEBPACK FOOTER //
// src/components/elements/order/NoveltyDataActions.vue